import React from 'react';
import cn from 'class-names';
import PropTypes from 'prop-types';
import styles from './NavLink.module.less';
import { withTheme } from '../ThemeProvider';

const getSizeClass = (size) => {
  switch (size) {
    case 'S': {
      return styles.three;
    }

    case 'M': {
      return styles.two;
    }

    case 'L': {
      return styles.one;
    }

    default: {
      return styles.two;
    }
  }
};

const NavLink = ({ selected, children, style, size }) => (
  <div className={cn(styles.navLinksSection, selected && styles.selected, getSizeClass(size))} style={style}>
    {children}
  </div>
);

NavLink.propTypes = {
  selected: PropTypes.bool,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  overlayMenu: PropTypes.bool,
  size: PropTypes.string,
};

NavLink.defaultProps = {
  selected: false,
  style: undefined,
  overlayMenu: false,
  size: 'M',
};

NavLink.displayName = 'NavLink';

export default withTheme(NavLink);
